(() => {
  if (window.ppMobileBuyLoaded) return;
  window.ppMobileBuyLoaded = true;
  const states = new WeakMap(), media = matchMedia('(max-width: 760px)');
  function init(root) {
    root.querySelectorAll('.pp-pdp').forEach(product => {
      if (states.has(product)) return;
      const controller = new AbortController();
      let row, slot, queued = false;
      const update = () => {
        queued = false;
        if (!product.isConnected) return;
        const current = product.querySelector('.f8pr-buy-button .submit');
        if (!current) return;
        if (current !== row) {
          row = current;
          slot = document.createElement('div'); slot.className = 'pp-mobile-buy-slot';
          row.before(slot); slot.append(row);
          row.dataset.ppTitle = product.querySelector('h1')?.textContent.trim() || '';
        }
        const offset = document.querySelector('[data-pp-trust] .pp-trust')?.getBoundingClientRect();
        const top = media.matches && offset?.top === 0 ? offset.bottom : 0;
        const button = row.querySelector('button[type="submit"]');
        const available = row.querySelector('[data-pp-quantity]') && button && !button.classList.contains('overlay-unavailable_buy_button');
        const stuck = Boolean(media.matches && available && slot.getBoundingClientRect().bottom <= top);
        if (stuck && !row.classList.contains('pp-mobile-buy--stuck')) slot.style.height = slot.getBoundingClientRect().height + 'px';
        row.classList.toggle('pp-mobile-buy--stuck', stuck);
        document.documentElement.classList.toggle('pp-mobile-buy-active', stuck);
        if (!stuck) slot.style.removeProperty('height');
      };
      const schedule = () => { if (!queued) { queued = true; requestAnimationFrame(update); } };
      window.addEventListener('scroll', schedule, { passive: true, signal: controller.signal });
      window.addEventListener('resize', schedule, { signal: controller.signal });
      product.addEventListener('change', schedule, { signal: controller.signal });
      const observer = new MutationObserver(schedule); observer.observe(product, { childList: true, subtree: true });
      states.set(product, { controller, observer }); update();
    });
  }
  const ready = () => init(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, { once: true }); else ready();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('.pp-pdp').forEach(product => {
    const state = states.get(product); state?.controller.abort(); state?.observer.disconnect(); states.delete(product);
    document.documentElement.classList.remove('pp-mobile-buy-active');
  }));
})();
